import { render, staticRenderFns } from "./food-order.vue?vue&type=template&id=0770ce2b&scoped=true"
import script from "./food-order.vue?vue&type=script&lang=js"
export * from "./food-order.vue?vue&type=script&lang=js"
import style0 from "./food-order.vue?vue&type=style&index=0&id=0770ce2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770ce2b",
  null
  
)

export default component.exports